var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "mail-detail-integration" } },
    [
      _c("div", { staticClass: "integrations" }, [
        _c("span", { staticClass: "fix-align" }, [
          _c("span", { staticClass: "img" }, [_c("MailIcon")], 1),
          _vm._v(" "),
          _c("span", [
            _c("div", { staticClass: "integration-name" }, [
              _vm._v(_vm._s(_vm.$t("mail.gmailForward"))),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "forwards" },
        [
          _c(
            "div",
            {
              staticClass: "forward forward-add",
              on: {
                click: function ($event) {
                  return _vm.gmailIntegration(true)
                },
              },
            },
            [
              _c("a-icon", { attrs: { type: "plus-circle", theme: "filled" } }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "text-large font-weight-bolder mt-2 text-large",
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("settings.newAdd")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.forwardAddresses, function (forwardAddress) {
            return _c(
              "div",
              { staticClass: "forward-item" },
              [
                _c(
                  "div",
                  { staticClass: "icon-container" },
                  [_c("MailIcon", { staticClass: "icon-mail" })],
                  1
                ),
                _vm._v(" "),
                _c("a-tooltip", { attrs: { title: forwardAddress.mail } }, [
                  _c("span", { staticClass: "forward-mail-address" }, [
                    _vm._v(_vm._s(forwardAddress.mail)),
                  ]),
                ]),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "integrations" }, [
        _c("span", { staticClass: "fix-align" }, [
          _c("span", { staticClass: "img" }, [_c("MicrosoftIcon")], 1),
          _vm._v(" "),
          _c("span", [
            _c("div", { staticClass: "integration-name" }, [
              _vm._v(_vm._s(_vm.$t("mail.outlookForward"))),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "forwards" },
        [
          _c(
            "div",
            {
              staticClass: "forward forward-add",
              on: {
                click: function ($event) {
                  return _vm.gmailIntegration(false)
                },
              },
            },
            [
              _c("a-icon", { attrs: { type: "plus-circle", theme: "filled" } }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "text-large font-weight-bolder mt-2 text-large",
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("settings.newAdd")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "forward forward-add addOutlookEmailWithOutVerification",
              on: {
                click: function ($event) {
                  return _vm.openForwardModal("microsoft")
                },
              },
            },
            [
              _c("a-icon", { attrs: { type: "plus-circle", theme: "filled" } }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "text-large font-weight-bolder mt-2 text-large",
                },
                [_vm._v(" " + _vm._s(_vm.$t("mail.mailAddForward")) + " ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.microsoftForwardAddresses, function (forwardAddress) {
            return _c(
              "div",
              { staticClass: "forward-item" },
              [
                _c(
                  "div",
                  { staticClass: "icon-container" },
                  [_c("MailIcon", { staticClass: "icon-mail" })],
                  1
                ),
                _vm._v(" "),
                _c("a-tooltip", { attrs: { title: forwardAddress.mail } }, [
                  _c("span", { staticClass: "forward-mail-address" }, [
                    _vm._v(_vm._s(forwardAddress.mail)),
                  ]),
                ]),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "integrations" }, [
        _c("span", { staticClass: "fix-align" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("span", [
            _c("div", { staticClass: "integration-name" }, [
              _vm._v(_vm._s(_vm.$t("message.otherEmailProviders"))),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "forwards" },
        [
          _c(
            "div",
            {
              staticClass:
                "forward forward-add addOutlookEmailWithOutVerification",
              on: {
                click: function ($event) {
                  return _vm.openForwardModal("other")
                },
              },
            },
            [
              _c("a-icon", { attrs: { type: "plus-circle", theme: "filled" } }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "text-large font-weight-bolder mt-2 text-large",
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("mail.mailAddForwarding")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.otherForwardAddresses, function (forwardAddress) {
            return _c(
              "div",
              { staticClass: "forward-item" },
              [
                _c(
                  "div",
                  { staticClass: "icon-container" },
                  [_c("MailIcon", { staticClass: "icon-mail" })],
                  1
                ),
                _vm._v(" "),
                _c("a-tooltip", { attrs: { title: forwardAddress.mail } }, [
                  _c("span", { staticClass: "forward-mail-address" }, [
                    _vm._v(_vm._s(forwardAddress.mail)),
                  ]),
                ]),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          staticClass: "testModal2",
          attrs: { title: _vm.$t("mail.routingSteps"), centered: "" },
          on: { ok: _vm.closeModal },
          model: {
            value: _vm.isGmailIntegration,
            callback: function ($$v) {
              _vm.isGmailIntegration = $$v
            },
            expression: "isGmailIntegration",
          },
        },
        [_c("div", [_c("gif-player", { attrs: { src: _vm.getGifSrc() } })], 1)]
      ),
      _vm._v(" "),
      _vm.showForwardModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title:
                  _vm.$t("message.addRouted") +
                  " - " +
                  _vm.forwardForm.type.toUpperCase(),
                "show-footer": false,
              },
              on: { cancel: _vm.handleForwardModalCancel },
            },
            [
              _c("div", { staticClass: "forward-form" }, [
                _c("div", [
                  _c("label", { attrs: { for: "sourceEmail" } }, [
                    _vm._v(_vm._s(_vm.$t("mail.forwardingEmailAddress"))),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.forwardForm.sourceEmail,
                        expression: "forwardForm.sourceEmail",
                      },
                    ],
                    attrs: { type: "email", id: "sourceEmail", required: "" },
                    domProps: { value: _vm.forwardForm.sourceEmail },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.forwardForm,
                          "sourceEmail",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", { attrs: { for: "destinationEmail" } }, [
                    _vm._v(_vm._s(_vm.$t("mail.whereHeDirected"))),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.forwardForm.destinationEmail,
                        expression: "forwardForm.destinationEmail",
                      },
                    ],
                    attrs: {
                      type: "email",
                      id: "destinationEmail",
                      readonly: "",
                    },
                    domProps: { value: _vm.forwardForm.destinationEmail },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.forwardForm,
                          "destinationEmail",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", { attrs: { for: "owner" } }, [
                    _vm._v(_vm._s(_vm.$t("mail.owner"))),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.forwardForm.owner,
                        expression: "forwardForm.owner",
                      },
                    ],
                    attrs: { type: "text", id: "owner", readonly: "" },
                    domProps: { value: _vm.forwardForm.owner },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.forwardForm, "owner", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "actions" },
                  [
                    _c(
                      "a-button",
                      { on: { click: _vm.handleForwardModalCancel } },
                      [_vm._v(_vm._s(_vm.$t("billing.cancel")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleFormModalSave },
                      },
                      [_vm._v(_vm._s(_vm.$t("message.save")))]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "img" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("mail")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }